import { render } from "./CategorySelect.vue?vue&type=template&id=3697f876&scoped=true"
import script from "./CategorySelect.vue?vue&type=script&lang=js"
export * from "./CategorySelect.vue?vue&type=script&lang=js"

import "./CategorySelect.vue?vue&type=style&index=0&id=3697f876&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3697f876"]])

export default __exports__